import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { ResetPassword } from './model';

import { LoginView } from 'portcall/login/view';
import { PasswordEntry } from 'portcall/passwordentry/view';
import { ValidationErrorView } from 'core/validationerror/view';

export const ResetPasswordView = SuperCritical(({ model: m } : { model : ResetPassword }) =>
    <div className="resetpassword pc-page-fixedwidth">
        <div className="pc-card resetpassword-container">
            <h2 className="pc-card-header pc-card-title">Reset password</h2>
            {m.ResetPasswordRequest()
                && m.ResetPasswordRequest()!.Response()
                && m.ResetPasswordRequest()!.Response()!.Success ?
                    <ResetPasswordSuccess model={m} /> :
                    m.Validation()['Token'] ?
                        <div>
                            Your password reset link is invalid. This is probably because your link expired.
                            Please try requesting another password reset link.
                        </div> :
                        <ResetPasswordForm model={m} />
            }
        </div>
        <LoginView modelContainer={m.Login} />
    </div>
);

let ResetPasswordForm = SuperCritical(({ model: m } : { model : ResetPassword }) =>
    <form>
        <div className="form-group">
            <PasswordEntry autoFocus
                value={m.ResetPassword.NewPassword}
                showValidation={m.ShowPasswordValidation}
                placeholder="New Password" />
            <ValidationErrorView error={() => m.Validation()['NewPassword']} />
        </div>
        <div className="form-group">
            <input type="password" className="form-control pc-input-box"
                placeholder="Confirm password"
                value={m.ResetPassword.ConfirmPassword() || ''}
                onChange={e => m.ResetPassword.ConfirmPassword(e.currentTarget.value)} />
            <ValidationErrorView error={() => m.Validation()['ConfirmPassword']} />
        </div>
        <div className="form-group form-buttons">
            <button className="pc-button pc-button-primary" onClick={noDefault(m.Submit)}>Reset</button>
        </div>
    </form>
);

let ResetPasswordSuccess = SuperCritical(({ model: m } : { model : ResetPassword }) =>
    <div>
        <div>
            Your password has been reset successfully.
        </div>
        <div className="login-link">
            <a href="" onClick={noDefault(() => m.ShowLogin(true))}>Login</a>
        </div>
        <div>
            <a href="#">Back to homepage</a>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/resetpassword/view.tsx